export class ExstTranslatorHelper {
  static encodeTextToSend(text) {
      const allSpacesPattern = / /g;
      const encodingSpaces = '%20';

      return text.replace(allSpacesPattern, encodingSpaces);
  };

  static decodeTextFromResponse(text) {
      const allSpacesPattern = /%20/g;
      const encodingSpaces = ' ';

      return text.replace(allSpacesPattern, encodingSpaces);
  };
}
